import { render, staticRenderFns } from "./ItemCreateDialog.vue?vue&type=template&id=53cf6ea0&scoped=true"
import script from "./ItemCreateDialog.vue?vue&type=script&lang=ts"
export * from "./ItemCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf6ea0",
  null
  
)

export default component.exports